export enum FeatureFlagKey {
  USER_MANAGEMENT = 'userManagement',
  OBJECTIVES = 'objectives',
}
